import { createColorSpot } from './template';
import { initFunctions } from './functions';

export class ColorSpot extends HTMLElement {
  constructor() {
    super();
    this.refs = {
      elem: this,
      data: JSON.parse(this.getAttribute('data-contents') ?? '[]'),
      layout: JSON.parse(this.getAttribute('data-layout') ?? '{}'),
      isEditingMode: this.getAttribute('data-editing-mode').toLowerCase() === 'true',
    };
  }

  connectedCallback() {
    if (!this.refs.data?.length || this.refs.isEditingMode) {
      return;
    }

    // Create template
    createColorSpot(this, this.refs);

    // Add eventlistener
    initFunctions(this);
  }
}
